import PropTypes from 'prop-types';
import IconPdf from '../../components/Icon/IconPdf';
import IconInformation from '../../components/Icon/IconInformation';

const OrderArchiveTableData = ({
    data,
    currentStatus,
    orderEditHandleFunction,
    currentPage,
    dataSize,
    requestDataFunction,
    requestOnlyPdfFunction,
}) => {
    const formatDate = (isoString) => {
        const date = new Date(isoString);
        return date.toLocaleString();
    };
    const itemsPerPage = 15;

    // Calculate pagination
    const totalPages = Math.ceil(dataSize / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage + 1;
    const endIndex = Math.min(startIndex + itemsPerPage - 1, dataSize);

    return (
        <>
            {data.map((order, orderIndex) => (
                <div className="flex flex-row w-full h-auto text-xs pt-1">
                    <div className="w-[15%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white">
                        <h2 className="text-center">SA_{order.orderId}{order.isRevised ? 'R' : ''}</h2>
                    </div>
                    <div className="w-[15%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white whitespace-pre-line">
                        <h2 className="text-center">{order.formData.customerName}</h2>
                    </div>
                    <div className="w-[15%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white whitespace-pre-line">
                        <h2 className="text-center">{order.formData.projectName}</h2>
                    </div>
                    <div className="w-[15%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white">
                        <h2 className="text-center">{order.formData.territoryEmail}</h2>
                    </div>
                    <div className="w-[15%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white">
                        <h2 className="text-center">{order.formData.ownerName}</h2>
                    </div>
                    <div className="w-[15%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white">
                        <h2 className="text-center">{formatDate(order.completed_at)}</h2>
                    </div>
                    <div className="w-[10%] flex justify-center items-center bg-[#ebf2f6] border-solid border-r-2 border-b-2 border-white">
                        <div className="flex flex-row w-full justify-evenly text-sm text-[#0d3857]">
                            <button
                                type="submit"
                                onClick={() => orderEditHandleFunction(orderIndex)}
                                className="p-2 group relative cursor-pointer"
                                aria-label="Complete Info"
                            >
                                <IconInformation />
                                <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-100 absolute bottom-full left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs py-1 px-1 rounded-md">
                                            Info
                                        </span>
                            </button>
                            <button
                                type="submit"
                                onClick={() => requestOnlyPdfFunction(order.orderId)}
                                className="p-2 group relative cursor-pointer"
                                aria-label="PDF"
                            >
                                <IconPdf />
                                <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-100 absolute bottom-full left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs py-1 px-1 rounded-md">
                                            PDF
                                        </span>
                            </button>
                        </div>
                    </div>
                </div>
            ))}

            {/* Pagination Controls */}
            <div className="flex flex-row w-full justify-between items-center pt-4">
                <div className="flex w-1/2">
                    Showing {startIndex} to {endIndex} of {dataSize} results
                </div>
                <div className="flex w-1/2 justify-end items-center">
                    <button
                        type="submit"
                        className="px-4 py-2 mx-2 bg-gray-200 rounded disabled:opacity-50"
                        onClick={() => requestDataFunction(currentStatus, -1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    <span className="px-4 py-2">{currentPage} / {totalPages}</span>
                    <button
                        type="submit"
                        className="px-4 py-2 mx-2 bg-gray-200 rounded disabled:opacity-50"
                        onClick={() => requestDataFunction(currentStatus, 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            </div>
        </>
    );
};

OrderArchiveTableData.propTypes = {
    data: PropTypes.array.isRequired,
    orderEditHandleFunction: PropTypes.func,
    currentStatus: PropTypes.string.isRequired,
    currentPage: PropTypes.number.isRequired,
    dataSize: PropTypes.number.isRequired,
    requestDataFunction: PropTypes.func.isRequired,
    requestOnlyPdfFunction: PropTypes.func,
};

OrderArchiveTableData.defaultProps = {
    orderEditHandleFunction: () => console.log('Default Order Edit Handle'),
    requestOnlyPdfFunction: () => console.log('Request Only PDF Function Handle'),
};

export default OrderArchiveTableData;
